import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  initiateLiveChat,
  searchWhatsAppMsgTemplate,
  sendWhatsAppMessage,
} from "../../store/actions/tenantAction";
import {
  getVariableComponent,
  onSelectTemplate,
} from "../../utils/TemplateHelper";

export const SendTemplateMsgBackground = forwardRef(({ isLiveChat = false, phoneNumbars, selectedTemplateId, onDone }, ref) => {
  const dispatch = useDispatch();
  const globalReducer = useSelector((state) => state.globalReducer);
  const [template, setTemplate] = useState({
    templateType: "GENERIC",
    category: "MARKETING",
    language: "English",
    header: { type: "HEADER", format: "" },
    body: "",
    footer: "",
    buttons: [],
  });
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [carouselTemplate, setCarouselTemplate] = useState([]);

  useEffect(() => {
    dispatch(
      searchWhatsAppMsgTemplate(
        {
          tenantId: globalReducer.loginInfo?.tenantId,
          criteria: {
            id: selectedTemplateId,
            tenantWabaId: globalReducer.waba?.id,
          },
          size: 100000,
          offset: 0,
          orderBy: [{ property: "id", direction: "DESC" }]
        },
        (swt) => {
          onSelectTemplate(
            swt.data ?? [],
            setSelectedTemplate,
            setTemplate,
            setCarouselTemplate,
            selectedTemplateId
          );
        }
      )
    );
  }, [globalReducer.waba]);


  const handleSubmit = () => {
    getVariableComponent(
      dispatch,
      globalReducer.loginInfo,
      globalReducer.waba,
      template,
      carouselTemplate
    ).then((componentsVal) => {
      if (componentsVal) {
        phoneNumbars.forEach((phoneNumbar) => {
          dispatch(
            sendWhatsAppMessage(
              {
                tenantId: globalReducer.loginInfo?.tenantId,
                contact: {
                  uid: globalReducer.loginInfo?.uid,
                  tenantId: globalReducer.loginInfo?.tenantId,
                  whatsappNumber: parseInt((phoneNumbar + "")?.replace("+", "")),
                },
                tenantWabaId: globalReducer.waba?.id,
                templateId: parseInt(selectedTemplateId),
                template: selectedTemplate,
                languageCode: selectedTemplate.language,
                messageType: selectedTemplate.messageType,
                type: "template",
                templateValue: { components: componentsVal },
              },
              (a) => {
                if (isLiveChat) {
                  dispatch(
                    initiateLiveChat(a, (d) => {
                      onDone();
                    })
                  );
                } else {
                  onDone();
                }
              }
            )
          );
        });
      }
    });
  };

  useImperativeHandle(ref, () => ({
    handleSubmit
  }));
  return <div></div>;
});

